import { isDevMode } from "./electron-modules";

interface LinkOptions {
  target?: string;
  name?: string;
}

export const backendHost = isDevMode
  ? "https://engine.solv3d.com"
  : "https://engine.solv3d.com";

export const frontendHost = isDevMode
  ? "https://engine.solv3d.com"
  : "https://engine.solv3d.com";

export const openExternalLink = (href, options:LinkOptions = {}) => {
  let element = document.createElement('a');

  element.setAttribute("href", href);

  if (options.target) {
    element.setAttribute("target", options.target);
  } else {
    element.setAttribute("target", "_blank");
  }

  if (options.name) {
    element.setAttribute('download', options.name);
  }

  element.style.display = 'none';
  document.body.appendChild(element);
  element.click();
  document.body.removeChild(element);
};